import { createRootRoute, createRoute } from '@tanstack/react-router'
import { App } from '@/app/App'
import { IndexPage } from '@/pages/index/IndexPage'
import { NotFoundPage } from '@/pages/not-found/NotFoundPage'
import { Base64Page } from '@/pages/base64/Base64Page'
import { HtmlEntitiesPage } from '@/pages/html-entities/HtmlEntitiesPage'
import { UrlCodecPage } from '@/pages/url-encode-decode/UrlCodecPage'
import { UtmGeneratorPage } from '@/pages/utm-generator'
import { CsvToJsonPage } from '@/pages/csv-v-json/CsvToJsonPage'
import { JsonToCsvPage } from '@/pages/json-v-csv/JsonToCsvPage'
import { HtmlFormatterPage } from '@/pages/html-formatter/HtmlFormatterPage'
import { JavaScriptFormatterPage } from '@/pages/javascript-formatter/JavaScriptFormatterPage'
import { CssFormatterPage } from '@/pages/css-formatter/CssFormatterPage'
import { JsonFormatterPage } from '@/pages/json-formatter/JsonFormatterPage'
import { JsonMinifierPage } from '@/pages/json-minifier/JsonMinifierPage'
import { SqlFormatterPage } from '@/pages/sql-formatter/SqlFormatterPage'
import { YamlFormatterPage } from '@/pages/yaml-formatter/YamlFormatterPage'
import { XmlFormatterPage } from '@/pages/xml-formatter/XmlFormatterPage'
import { UuidGeneratorPage } from '@/pages/uuid-generator/UuidGeneratorPage'
import { RegexTesterPage } from '@/pages/regex-tester/RegexTesterPage'
import { CronGeneratorPage } from '@/pages/cron-generator/CronGeneratorPage'
import { JwtDecoderPage } from '@/pages/jwt-decoder/JwtDecoderPage'
import { HashGeneratorPage } from '@/pages/hash-generator/HashGeneratorPage'
import { TextDiffPage } from '@/pages/text-diff/TextDiffPage'
import { MarkdownEditorPage } from '@/pages/markdown-editor'
import { BlogIndexPage } from '@/pages/blog/BlogIndexPage'
import { BlogPostPage } from '@/pages/blog/BlogPostPage'

const rootRoute = createRootRoute({
  component: App,
  notFoundComponent: NotFoundPage,
})

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})

const base64Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/base64',
  component: Base64Page,
})

const htmlEntitiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/html-entities',
  component: HtmlEntitiesPage,
})

const urlCodecRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/url-encode-decode',
  component: UrlCodecPage,
})

const utmGeneratorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/utm-generator',
  component: UtmGeneratorPage,
})

const csvToJsonRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/csv-v-json',
  component: CsvToJsonPage,
})

const jsonToCsvRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/json-v-csv',
  component: JsonToCsvPage,
})

const htmlFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/html-formatter',
  component: HtmlFormatterPage,
})

const javascriptFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/javascript-formatter',
  component: JavaScriptFormatterPage,
})

const cssFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/css-formatter',
  component: CssFormatterPage,
})

const jsonFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/json-formatter',
  component: JsonFormatterPage,
})

const jsonFormatterEnRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/en/json-formatter',
  component: JsonFormatterPage,
})

const jsonMinifierRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/json-minifier',
  component: JsonMinifierPage,
})

const jsonMinifierEnRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/en/json-minifier',
  component: JsonMinifierPage,
})

const sqlFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/sql-formatter',
  component: SqlFormatterPage,
})

const yamlFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/yaml-formatter',
  component: YamlFormatterPage,
})

const yamlFormatterEnRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/en/yaml-formatter',
  component: YamlFormatterPage,
})

const xmlFormatterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/xml-formatter',
  component: XmlFormatterPage,
})

const xmlFormatterEnRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/en/xml-formatter',
  component: XmlFormatterPage,
})

const uuidGeneratorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/uuid-generator',
  component: UuidGeneratorPage,
})

const regexTesterRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/regex-tester',
  component: RegexTesterPage,
})

const cronGeneratorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cron-generator',
  component: CronGeneratorPage,
})

const jwtDecoderRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/jwt-decoder',
  component: JwtDecoderPage,
})

const hashGeneratorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/hash-generator',
  component: HashGeneratorPage,
})

const textDiffRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/text-diff',
  component: TextDiffPage,
})

const markdownEditorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/markdown-editor',
  component: MarkdownEditorPage,
})

const blogIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog',
  component: BlogIndexPage,
})

const blogPostRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog/$slug',
  component: BlogPostPage,
})

export const routeTree = rootRoute.addChildren([
  indexRoute,
  base64Route,
  htmlEntitiesRoute,
  urlCodecRoute,
  utmGeneratorRoute,
  csvToJsonRoute,
  jsonToCsvRoute,
  htmlFormatterRoute,
  javascriptFormatterRoute,
  cssFormatterRoute,
  jsonFormatterRoute,
  jsonFormatterEnRoute,
  jsonMinifierRoute,
  jsonMinifierEnRoute,
  sqlFormatterRoute,
  yamlFormatterRoute,
  yamlFormatterEnRoute,
  xmlFormatterRoute,
  xmlFormatterEnRoute,
  uuidGeneratorRoute,
  regexTesterRoute,
  cronGeneratorRoute,
  jwtDecoderRoute,
  hashGeneratorRoute,
  textDiffRoute,
  markdownEditorRoute,
  blogIndexRoute,
  blogPostRoute,
])
